import { createSlice } from "@reduxjs/toolkit";
import { ReorderState } from "./reorder.state";
import { getReorderProducts } from "./reorder.thunk";

const initialState: ReorderState = {
  data: null,
  status: "idle",
  error: null,
  currentPage: 1,
  hasMore: true,
};

export const reorderSlice = createSlice({
  name: "reorder",
  initialState,
  reducers: {
    resetReorder: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = null;
      state.currentPage = 1;
      state.hasMore = true;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReorderProducts.pending, (state, action) => {
        const isFirstPage = !action.meta.arg || action.meta.arg.page === 1;
        
        if (isFirstPage) {
          state.data = null;
        }
        
        state.status = "loading";
        state.error = null;
      })
      .addCase(getReorderProducts.fulfilled, (state, action) => {
        state.status = "success";
        
        const responseData = action.payload.data;
        
        // If it's page 1, replace data. Otherwise, append to existing data
        if (responseData.pagination.current_page === 1) {
          state.data = responseData;
        } else if (state.data) {
          // Append new items to existing items
          state.data = {
            ...responseData,
            items: [...state.data.items, ...responseData.items],
          };
        } else {
          state.data = responseData;
        }

        state.currentPage = responseData.pagination.current_page;
        state.hasMore = responseData.pagination.next_page_url !== null;
      })
      .addCase(getReorderProducts.rejected, (state, action) => {
        state.status = "error";
        state.error =
          action.payload ?? "Ürünler yüklenirken bir hata oluştu.";
      });
  },
});

export const { resetReorder, setCurrentPage } = reorderSlice.actions;

export default reorderSlice.reducer;